import { useShopPageContainer } from "@b2bportal/core-cars";

import { useShopPageRoute } from "@tenant/cars";
import type { PackageCarsShopPageProps } from "../types";
import { usePackageCarsShopPageFetch } from "./usePackageCarsShopPageFetch";

export const usePackageCarsShopPage = (props: PackageCarsShopPageProps) => {
  const data = useShopPageRoute();

  usePackageCarsShopPageFetch(data.shopRequest);

  const containerProps = {
    goToNextStep: () => {
      // TODO(Nate): implement next step
    },
  };

  return useShopPageContainer({
    ...data,
    goToNextStep: containerProps.goToNextStep,
  });
};
